import logger from '../utils/logger';
import React, {useState} from 'react';
import { Link } from "react-router-dom";
import jsPDF from 'jspdf';
import NewSignature from '../utils/NewSignature';
import '../style/CtContrastConsent.css';

export default function CtContrastConsent() {
    const [formData, setFormData] = useState({
        imagingType: 'CT',
        unableToConsent: false,
        reason: '',
        patientSignature: '',
        responsibleName: '',
        relationship: '',
        technologist: '',
        signatureImage: null,
    });

    const timestamp = new Date().toLocaleString(); // e.g., "7/17/2025, 4:32:10 PM"

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
        };

const generatePDF = async () => {
    const doc = new jsPDF();
    const leftMargin = 20;
    const contentWidth = 170;
    const baseLineHeight = 8;
    const elementSpacing = 4;
    const maxYPosition = 270;
    const logoWidth = 30;
    const logoHeight = 30;
    const xPositionLogo = doc.internal.pageSize.getWidth() - leftMargin - logoWidth;
    const yPositionLogo = 10;

    const logoImagePath = "/img/health_guardian.jpeg"; // Adjust this path based on your project structure

  // Optional: Base64-encoded image (uncomment to use instead of file path)
//   const logoImageData = "data:image/png;base64,iVBORw0KGgo..."; // Replace with actual base64 string

  // Helper function to load image and return data URL
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      // logger.log(`Attempting to load image from: ${src}`);
      const img = new Image();
      img.onload = () => {
        // logger.log(`Image loaded successfully: ${src}`);
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = (error) => {
        logger.error("Failed to load image", error);
        reject(new Error("Failed to load image"));
      };
      img.src = src;
    });
  };

    try {
    const imgData = await loadImage(logoImagePath); // or use base64
    doc.addImage(imgData, "PNG", xPositionLogo, yPositionLogo, logoWidth, logoHeight, undefined, 'FAST');
    } catch (error) {
    logger.warn("Logo failed to load, using fallback text");
    doc.setFontSize(10);
    doc.setFont("helvetica", "italic");
    doc.text("Health Hub Logo", xPositionLogo, yPositionLogo + 10);
    }
        
     let y = 30;

    const timestamp = new Date().toLocaleString();

    const checkPageOverflow = (linesCount = 1) => {
        const totalHeight = linesCount * baseLineHeight + elementSpacing;
        if (y + totalHeight > maxYPosition) {
        doc.addPage();
        y = 20;
        }
    };

    const addWrappedText = (text) => {
        const lines = doc.splitTextToSize(text || 'N/A', contentWidth);
        checkPageOverflow(lines.length);
        doc.text(lines, leftMargin, y);
        y += lines.length * baseLineHeight;
    };

    const addStyledField = (label, value) => {
        checkPageOverflow();
        doc.setTextColor("#808080");
        doc.text(`${label}:`, leftMargin, y);
        const labelWidth = doc.getTextWidth(`${label}: `);
        doc.setTextColor("#000000");
        doc.text(`${value || "N/A"}`, leftMargin + labelWidth + 1, y);
        y += baseLineHeight + elementSpacing;
    };

    const drawHeader = (text) => {
        checkPageOverflow();
        // doc.setFillColor("#87CEFA"); // Light blue
        // doc.rect(leftMargin, y, contentWidth, baseLineHeight + 2, "F");
        doc.setTextColor("#000000");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(24);
        doc.text(text, leftMargin, y + baseLineHeight);
        y += baseLineHeight + elementSpacing;
        doc.setTextColor("#000000");
        y += elementSpacing;
    };

    drawHeader(`${formData.imagingType} Contrast Consent`);

    //     doc.setLineWidth(0.5);
    // doc.line(leftMargin, y, doc.internal.pageSize.getWidth() - leftMargin, y);
    // y += baseLineHeight + elementSpacing;


  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  // Consent Text
  const consentText = [
    'I understand that the use of contrast material is not without risk and may cause undesirable side effects, such as injury to a nerve, artery or vein and tissue damage at the injection site and/or adjacent areas.',
    'Occasionally, allergic reactions, chills or hives and/or heart or blood pressure problems can occur. Very rarely, a life-threatening reaction could occur. The physicians and staff of Health Guardian are well trained to treat these reactions.',
    'I understand that in the case of pregnant patients, permanent impairment of the unborn fetus has been associated with the use of contrast material. I certify to the best of my knowledge that I am not pregnant.',
    'I have read or have had read to me the contrast consent. I have had the opportunity to ask questions and had these questions answered.'
  ];

  consentText.forEach(paragraph => addWrappedText(paragraph));

  // Consent Status
  addStyledField("Patient is able to give consent", formData.unableToConsent ? "No" : "Yes");

  // Responsible Party Info
  if(formData.unableToConsent == true){
    addStyledField("State the reason", formData.unableToConsent ? formData.reason || "N/A" : "N/A");
    addStyledField("Responsible Adult Full Name", formData.responsibleName);
    addStyledField("Relationship to patient", formData.relationship);
  }

    addStyledField("Technologist / Tech Assistant", formData.technologist);
    addStyledField("Patient / Responsible Adult Signature", formData.patientSignature);

  // Signature Image
  if (formData.signatureImage) {
    checkPageOverflow();
    doc.text("Electronic Signature:", leftMargin, y);
    y += baseLineHeight;

    try {
      const imgProps = doc.getImageProperties(formData.signatureImage);
      const imgWidth = 100;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      checkPageOverflow(Math.ceil(imgHeight / baseLineHeight));
      doc.addImage(formData.signatureImage, "PNG", leftMargin, y, imgWidth, imgHeight);
      y += imgHeight + elementSpacing;
      doc.text(`Signed by ${formData.patientSignature} on: ${timestamp}`, leftMargin, y);
      y += baseLineHeight + elementSpacing;
    } catch (error) {
      logger.error("Error adding signature image:", error);
      addWrappedText("Signature image could not be loaded.");
    }
  }

  doc.save(`${formData.imagingType}_Contrast_Consent.pdf`);
};



  return (
  <div className="ct-consent-container">
    <Link to="/home"><button className='ris-little-blue-button'>Home</button></Link>
    <h2>{formData.imagingType} Contrast Consent Form</h2>
    <p>I understand that the use of contrast material is not without risk and may cause undesirable side effects, such as injury to a nerve, artery or vein and tissue damage at the injection site and/or adjacent areas.</p>
    <p>Occasionally, allergic reactions, chills or hives and/or heart or blood pressure problems can
    occur. Very rarely, a life-threatening reaction could occur.
    The physicians and staff of Health Guardian are well trained to treat these reactions.
    I understand that in the case of pregnant patients, permanent impairment of the unborn fetus
    has been associated with the use of contrast material. I certify to the best of my knowledge that I am not pregnant. </p>
    <p>I have read or have had read to me the contrast consent. I have had the opportunity to ask
    questions and had these questions answered.
    </p>
    
    <div className="checkbox-group">
      <label>Imaging Type:</label>
        <select
          value={formData.imagingType}
          onChange={(e) => handleChange('imagingType', e.target.value)}
        >
          <option value="MRI">MRI</option>
          <option value="CT">CT</option>
          <option value="US">US</option>
          <option value="DEXA">DEXA</option>
          <option value="XRAY">XRAY</option>
        </select>
    <label>
        Patient is able to give consent
        <input
        type="radio"
        name="consent"
        value="yes"
        checked={!formData.unableToConsent}
        onChange={(e) => handleChange('unableToConsent', false)}
        />
        Yes
        <input
        type="radio"
        name="consent"
        value="no"
        checked={formData.unableToConsent}
        onChange={(e) => handleChange('unableToConsent', true)}
        />
        No
    </label>
    </div>

    {formData.unableToConsent && (
    <>
        <label>State the reason:</label>
        <input
        type="text"
        placeholder="State reason if applicable"
        value={formData.reason}
        onChange={(e) => handleChange('reason', e.target.value)}
        />

        <label>Responsible Adult Full Name:</label>
        <input
        type="text"
        placeholder="Full Name"
        value={formData.responsibleName}
        onChange={(e) => handleChange('responsibleName', e.target.value)}
        />
    
        <label>Relationship to Patient:</label>
        <input
        type="text"
        placeholder="Relationship"
        value={formData.relationship}
        onChange={(e) => handleChange('relationship', e.target.value)}
        />
        </>
    )}

    

    <label>Technologist / Tech Assistant:</label>
    <input
      type="text"
      placeholder="Technologist Name"
      value={formData.technologist}
      onChange={(e) => handleChange('technologist', e.target.value)}
    />

    <label>Patient / Responsible Adult Signature:</label>
     <input
        type="text"
        placeholder="Signature"
        value={formData.patientSignature}
        onChange={(e) => handleChange('patientSignature', e.target.value)}
      />
    <NewSignature onSignatureSave={(sig) => handleChange('signatureImage', sig)} />

    <button className="PrimaryButton" onClick={generatePDF}>
      Generate PDF
    </button>
  </div>
);

}